import { render, staticRenderFns } from "./ActivateRoleModal.vue?vue&type=template&id=4949cfa3"
import script from "./ActivateRoleModal.vue?vue&type=script&lang=js"
export * from "./ActivateRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports